import { isProduction } from '../utils/common';

export const CMS_CDN = process.env.NEXT_PUBLIC_CMS_CDN_BASE_URL as string;

// 임시 Preview 검증 브랜치에서는 Vercel Preview에도 GTM을 로드한다.
const isVercelPreview = process.env.NEXT_PUBLIC_VERCEL_ENV === 'preview';
export const googleTagManagerId =
  process.env.NEXT_PUBLIC_GTM_ID?.trim() ||
  (isVercelPreview ? 'GTM-KVN2S26M' : undefined);
export const shouldLoadGoogleTagManager =
  (isProduction || isVercelPreview) &&
  Boolean(googleTagManagerId) &&
  /^GTM-[A-Z0-9]+$/.test(googleTagManagerId ?? '');
